/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module CinematicModule
 */

import {
    Component,
    ElementRef,
    Input,
    OnInit,
    Renderer2,
} from '@angular/core';
import './cinematic-tab-section.component.less';

/**
 * @description
 *     Component used to wrap a section in the cinematic view to create a tab for navigation.
 *     Adding tabs dynamically is not supported - tabs are added when the view is initialized.
 * @author Zhiqian Liu
 */
@Component({
    selector: 'cinematic-tab-section',
    template: '<ng-content></ng-content>',
})
export class CinematicTabSectionComponent implements OnInit {
    /**
     * Text to show in the header.
     */
    @Input()
    public tabTitle = '';

    /**
     * ID of the DOM element, created by replacing special characters and spaces of the tabTitle.
     */
    public tabId: string;

    constructor(
        public elementRef: ElementRef,
        private renderer: Renderer2,
    ) {}

    /** @override */
    public ngOnInit(): void {
        const { nativeElement } = this.elementRef;

        this.tabId = this.tabTitle.replace(/[^\w]/gi, '-').toLowerCase();
        this.renderer.addClass(nativeElement, 'cinematic-tab-section');
        this.renderer.setAttribute(nativeElement, 'id', this.tabId);
    }
}
